import SubCategoriesFieldsContainer from "./SubCategoriesFieldsContainer";

export default SubCategoriesFieldsContainer;
